/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Temporisation_Frost_Free_ModeInputs */



/**
* | output |
* | --- |
* | "Boiler start delay" |
*
* @param {Temporisation_Frost_Free_ModeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const temporisation_frost_free_mode = /** @type {((inputs?: Temporisation_Frost_Free_ModeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Temporisation_Frost_Free_ModeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Boiler start delay")
	return /** @type {LocalizedString} */ ("Temporisation démarrage chaudière")
});